import React from "react";

interface PrimaryButtonProps {
  children: React.ReactNode;
  type?: "button" | "submit" | "reset" | undefined;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  onClick,
  children,
  type,
  disabled,
  className,
}) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      type={type || "button"}
      className={`w-full h-min rounded-md bg-blue-500 text-white font-bold px-4 py-2 border border-blue-500 hover:bg-blue-600 flex items-center justify-center transition-colors ${
        disabled
          ? "bg-gray-300 pointer-events-none border-gray-50 text-gray-900"
          : ""
      } ${className || ""}`}
    >
      {children}
    </button>
  );
};

export default PrimaryButton;
